import React from "react";
import { Inbox } from "lucide-react";

/**
 * What a table or panel shows when it has nothing to show.
 *
 * The pages previously rendered a single muted sentence, which reads the same
 * whether the data set is genuinely empty or a filter just excluded everything
 * — the two need different reactions from the operator. So this takes a title
 * (the state) separately from a description (what to do about it), and an
 * optional action for when there is a next step worth offering.
 */
const EmptyState = ({
  icon = <Inbox size={28} />,
  title = "Nothing here yet",
  description,
  action,
  compact = false,
}) => (
  <div
    className={`flex flex-col items-center justify-center text-center ${
      compact ? "px-6 py-10" : "px-6 py-16"
    }`}
  >
    <div
      className="flex items-center justify-center rounded-full mb-3"
      style={{
        width: 56,
        height: 56,
        background: "var(--brand-light)",
        color: "var(--brand)",
      }}
    >
      {icon}
    </div>

    <p className="text-base font-semibold" style={{ color: "var(--main-text)" }}>
      {title}
    </p>

    {description && (
      <p
        className="mt-1.5 text-sm max-w-md"
        style={{ color: "var(--main-text-muted)" }}
      >
        {description}
      </p>
    )}

    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
